import { render, staticRenderFns } from "./menu-add.vue?vue&type=template&id=6d3af64f&scoped=true&"
import script from "./menu-add.vue?vue&type=script&lang=js&"
export * from "./menu-add.vue?vue&type=script&lang=js&"
import style0 from "./menu-add.vue?vue&type=style&index=0&lang=css&"
import style1 from "./menu-add.vue?vue&type=style&index=1&id=6d3af64f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3af64f",
  null
  
)

export default component.exports